import useSWR, { SWRConfiguration } from "swr"

const useMutationState = <T>(key: string, config?: SWRConfiguration) => {
  const { data, ...rest } = useSWR<T>(key, config)

  return { data: data as T, ...rest }
}

export { useMutationState }
